module.exports = __webpack_public_path__ + "img/pluglead.10b8f6fb.png";